import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {ExemptionTijpoort} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-visit-exemptions-exemption-tijpoort',
    templateUrl: './exemption_tijpoort.html',
    styleUrls: ['./exemption_tijpoort.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExemptionTijpoortComponent extends ExemptionBaseComponent {
  @Input() exemption : ExemptionTijpoort;
}

